import React from 'react';

import { IconSize, SvgIcon } from './SvgIcon';

interface IconProps {
  size?: IconSize;
}

const PaymentGoogleMicrosoft = (props: IconProps): JSX.Element => (
  <SvgIcon size={props.size}>
    <path d="M17 11H11V17H17V11Z" fill="#F35325" />
    <path d="M24 11H18V17H24V11Z" fill="#81BC06" />
    <path d="M17 18H11V24H17V18Z" fill="#05A6F0" />
    <path d="M24 18H18V24H24V18Z" fill="#FFBA08" />
    <path
      d="M11.9996 6.0999C11.9996 5.6999 11.9996 5.2999 11.8996 4.8999H6.09961V7.1999H9.39961C9.29961 7.9999 8.79961 8.5999 8.19961 9.0999V10.5999H10.1996C11.3996 9.3999 12.0996 7.7999 11.9996 6.0999Z"
      fill="#4285F4"
    />
    <path
      d="M6.1002 12.0001C7.6002 12.0001 9.0002 11.5001 10.2002 10.6001L8.2002 9.1001C7.6002 9.4001 6.8002 9.6001 6.1002 9.6001C4.6002 9.6001 3.2002 8.6001 2.7002 7.1001H0.700195V8.6001C1.7002 10.7001 3.8002 12.0001 6.1002 12.0001Z"
      fill="#34A853"
    />
    <path
      d="M2.70039 7.1998C2.40039 6.4998 2.40039 5.5998 2.70039 4.8998V3.2998H0.700391C-0.199609 4.9998 -0.199609 6.9998 0.700391 8.6998L2.70039 7.1998Z"
      fill="#FBBC04"
    />
    <path
      d="M6.09961 2.4C6.99961 2.4 7.79961 2.7 8.39961 3.3L10.1996 1.6C9.09961 0.5 7.59961 0 6.09961 0C3.79961 0 1.69961 1.3 0.599609 3.3L2.59961 4.8C3.19961 3.4 4.59961 2.4 6.09961 2.4Z"
      fill="#EA4335"
    />
  </SvgIcon>
);

export default PaymentGoogleMicrosoft;
